import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */
export default () => {
  function init() {
    const target = '#recommendations-collection';
    new Swiper(target, {
      loop: true,
      observer: true,
      // init: false,
      navigation: {
        nextEl: '.swiper-button-next--recommendations',
        prevEl: '.swiper-button-prev--recommendations',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      centeredSlides: false,
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 5,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        440: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        822: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1352: {
          slidesPerView: 4,
          // spaceBetween: 50,
        },
      },
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
